import { HttpClient, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/takeWhile';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { api } from '../api';
import { ResumeDTO } from './resume.dto';
import { Storage } from '../constants';

@Injectable()
export class ResumeService {
  public resume: any;
  private resumeOptions: any;
  private configs: any = {};
  public resumeId: any;
  public resumeAction: any;
  public linkedInResume: any;
  private denormalConfigs: any = {};
  private timelineObjectMap = {
    'WORKEXPERIENCE': { dto: 'workExperience', icon: 'fa-briefcase' },
    'AWARDS': { dto: 'awards', icon: 'fa-trophy fa-lg' },
    'MEMBERSHIPS': { dto: 'memberships', icon: 'fa-users fa-lg' },
    'LANGUAGES': { dto: 'languages', icon: 'fa-comment fa-lg' },
    'SKILLS': { dto: 'skills', icon: 'fa-gears fa-lg' },
    'CERTIFICATIONS': { dto: 'certifications', icon: 'fa-certificate fa-lg' },
    'EDUCATION': { dto: 'education', icon: 'fa-graduation-cap fa-lg' },
    'PROJECTEXPERIENCE': { dto: 'projectExperience', icon: 'fa-folder fa-lg' },
    'OBJECTIVE': { dto: 'objective', icon: 'fa-video-camera' },
    'TRAVELPREFERENCES': { dto: 'locationPreference', icon: '' },
    'EXPERIENCE LEVEL': { dto: 'careerHistory', icon: '' },
    'ATTACHMENTS': { dto: 'attachments', icon: '' },
    'CUSTOM':{dto:'optional',icon: ''}
  };

  private timelineFilterKey;
  addResumeFromScratch = false;
  reviewAndConfirm = false;
  fromEditResume = false;
  fromGetMatched = false;
  resumeFromRegistration = false;
  fromCreateResume = false;
  constructor(public http: HttpClient) {
  }

  getTimelineFilterKey() {
    return this.timelineFilterKey;
  }

  setTimelineFilterKey(key) {
    this.timelineFilterKey = key;
  }
  getTimelineMap() {
    return this.timelineObjectMap;
  }

  getResumeConfigData() {
    const httpParams = new HttpParams()
      .set('modelName', 'Resume');

    return this.http.get(api.configuration.EXTENDED_SECTION_CONFIGRATION, { params: httpParams })
      .map(res => {
        this.denormalConfigs = res;
        this.normalizeConfigs(this.denormalConfigs);
        return this.denormalConfigs;
      })
      .catch(this.handleError);
  }

  getResumeData() {
    return this.http.get<ResumeDTO[]>(api.resume.GET_PERSON_RESUMES)
      .flatMap(data => {
        this.resumeId = -1;
        if (data == null || data.length === 0) {
          return Observable.of(null);
        }
        const resume = data.filter(a => a.primaryFlag === 1)[0];
        if (resume) {
          this.resumeId = resume.id;
        }
        return this.getResumeDataByID(this.resumeId);
      })
      .map(res => {
        if (res) {
          this.resume = res;
          return this.resume;
        } else {
          this.resume = {
            primaryFlag: 1,
            importedFrom: 0
          };
          return 'NO_RESUME';
        }
      })
      .catch(this.handleError);
  }

  getResumeDataByID(resumeId) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('resumeId', resumeId);
    return this.http.get(api.resume.GET_RESUME_DATA, { params: httpParams });
  }

  getMaxStars(config) {
    if (config.modelFields && config.modelFields.length > 0) {
      const starsConfig = config.modelFields.filter(a => a.fieldName === 'SkillRating');
      if (starsConfig && starsConfig.length > 0) {
        const attrsList = starsConfig[0].attributes.filter(a => a.name === 'stars');
        if (attrsList && attrsList.length > 0) {
          return attrsList[0].value;
        }
      }
    }
    return 5;
  }

  getResumeId() {
    return this.resumeId;
  }

  getPersonResumes() {
    return this.http.get(api.resume.GET_PERSON_RESUMES)
      .catch(this.handleError);
  }

  saveResumeData(resumeObj: any) {
    return this.http.post(api.resume.SAVE_EDITED_RESUME, resumeObj)
      .catch(this.handleError);
  }

  getSaveResumeDTO() {
    return {
      'UserId': this.resume['userId'],
      'OwnerId': this.resume['ownerId'],
      'Reference': this.resume['reference'],
      'id': this.resume['id'],
      'Created': this.resume['created'],
      'CreatedBy': this.resume['createdBy'],
      'Modified': this.resume['modified'],
      'ModifiedBy': this.resume['modifiedBy'],
      'PrimaryFlag': this.resume['primaryFlag'],
      'ResumeDescription': this.resume['resumeDescription'],
      'ResumeName': this.resume['resumeName'],
      'Optional': this.resume['optional'],
      'ImportedFrom': this.resume['importedFrom'],
    };
  }

  getCertificationsList(page: number, count: number, searchString: string) {
    const httpParams = this.getHttpParams(page, count, searchString);

    return this.http.get(api.lookups.CERTIFICATES_LIST, { params: httpParams })
      .catch(this.handleError);
  }

  getSchoolsList(page: number, count: number, searchString: string) {
    const httpParams = this.getHttpParams(page, count, searchString);

    return this.http.get(api.lookups.SCHOOLS_LIST, { params: httpParams })
      .catch(this.handleError);
  }

  getSkillsList(page: number, count: number, searchString: string) {
    const httpParams = this.getHttpParams(page, count, searchString);

    return this.http.get(api.lookups.SKILLS_LIST, { params: httpParams })
      .catch(this.handleError);
  }

  getManagerInfo() {
    return this.http.get(api.resume.GET_MANGER_INFO)
      .catch(this.handleError);
  }

  getSelectedResumeOption(key) {
    return this.resumeOptions[key];
  }

  getAllResumeOptions() {
    return this.http.get(api.resume.RESUME_OPTIONS)
      .map(res => {
        this.resumeOptions = res;
        return this.resumeOptions;
      })
      .catch(this.handleError);
  }

  getResumeValue(key) {
    return this.resume ? this.resume[key] : null ;
  }

  getConfigValue(key) {
    return this.configs[key];
  }

  setResume(resume)  {
    this.resume = resume;
    if (resume !== undefined) {
      this.resumeId = resume.id;
    }
  }
  getResume()  {
    return this.resume;
  }
  getResumeConfig(key) {
    return this.configs[key];
  }

  private normalizeConfigs(data) {
    for (let i = 0; i < data.sections.length; i++) {
      for (let j = 0; j < data.sections[i].sections.length; j++) {
        if (data.sections[i].sections[j].name === 'TIMELINE') {
          const tlData = data.sections[i].sections[j].sections;
          for (let k = 0; k < tlData.length; k++) {
            this.configs[tlData[k].name] = tlData[k];
          }
        }
        this.configs[data.sections[i].sections[j].name] = data.sections[i].sections[j];
      }
    }
  }

  getWorkerPersonalDetails() {
    return this.http.get(api.candidate.WORKER_PERSONAL_DETAILS)
      .catch(this.handleError);
  }

  getResumeImportedFrom() {
    return this.http.get(api.resume.GET_RESUME_IMPORT_FROM)
      .catch(this.handleError);
  }

  private getHttpParams(page: number, count: number, searchString: string): HttpParams {
    if (searchString && searchString !== '') {
      const httpParams = new HttpParams()
        .set('page', page.toString())
        .set('maxItems', count.toString())
        .set('searchString', searchString.toString());
      return httpParams;
    } else {
      const httpParams = new HttpParams()
        .set('page', page.toString())
        .set('maxItems', count.toString());
      return httpParams;
    }
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  setFromEditResume(value) {
    this.fromEditResume = value;
  }

  getFromEditResume() {
    return this.fromEditResume;
  }

  setFromGetMatched(value) {
    this.fromGetMatched = value;
  }

  getFromGetMatched() {
    return this.fromGetMatched;
  }

  setAddResumeFromScratch(value) {
    this.addResumeFromScratch = value;
  }

  getAddResumeFromScratch() {
    return this.addResumeFromScratch;
  }

  setFromCreateResume(value) {
    this.fromCreateResume = value;
  }

  getFromCreateResume() {
    return this.fromCreateResume;
  }

  setReviewAndConfirm(value) {
    this.reviewAndConfirm = value;
  }

  getReviewAndConfirm() {
    return this.reviewAndConfirm;
  }

  setResumeFromRegistration(value) {
    this.resumeFromRegistration = value;
  }

  getResumeFromRegistration() {
    return this.resumeFromRegistration;
  }

  getIconClassByFileName(fileName: string) {
    const text = fileName;
    if ((/.doc/).test(text) || (/.docx/).test(text) || (/.docm/).test(text)) {
      return 'fa fa-file-word-o';
    } else if ((/.xls/).test(text) || (/.xlsx/).test(text) || (/.xlsm/).test(text)) {
      return 'fa fa-file-excel-o';
    } else if ((/.png/).test(text) || (/.jpeg/).test(text) || (/.gif/).test(text) || (/.jpg/).test(text)) {
      return 'fa fa-file-photo-o';
    } else if ((/.pdf/).test(text) || (/.pdfx/).test(text)) {
      return 'fa fa-file-pdf-o';
    } else if ((/.7z/).test(text) || (/.zip/).test(text) || (/.rar/).test(text)) {
      return 'fa fa-file-zip-o';
    } else if ((/.mpg/).test(text) || (/.mp4/).test(text) || (/.mpeg/).test(text) || (/.avi/).test(text) || (/.mov/).test(text)) {
      return 'fa fa-file-video-o';
    } else if ((/.mp3/).test(text) || (/.wmv/).test(text)) {
      return 'fa fa-file-sound-o';
    } else if ((/.txt/).test(text)) {
      return 'fa fa-file-text';
    } else {
      return 'fa fa-file';
    }
  }

  setResumeAction(resumeActions: any) {
    window.localStorage.setItem(Storage.RESUME_ACTIONS, JSON.stringify(resumeActions));
  }

  getResumeAction() {
    return JSON.parse(window.localStorage.getItem(Storage.RESUME_ACTIONS));
  }

  parseLinkedInResumeData(resumeObj: any) {
    return this.http.post(api.resume.LINKEDIN_PARSE_RESUME, resumeObj)
      .toPromise();
  }

}



// WEBPACK FOOTER //
// ../UI/src/app/shared/resume/resume.service.ts